import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { deactivateDeviceToken } from "../services/notification";

const useInactivityLogout = (timeoutDuration = 2 * 24 * 60 * 60 * 1000) => {
  // 2 days = 172,800,000 ms

  const navigate = useNavigate();

  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(async () => {
        // Deactivate device before clearing tokens
        try {
          await deactivateDeviceToken();
        } catch (e) {
          // Non-critical: proceed with logout
        }
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("darkMode");
        toast.error("You've been logged out due to inactivity.", {
          duration: 6000,
        });
        navigate("/login");
      }, timeoutDuration);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(inactivityTimer);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeoutDuration]);
};

export default useInactivityLogout;
